import { setSessionStorage } from '@cat-ecom/common/utils/storageUtils';
import { FOCUS_SERVICE_INSIGHT, SERVICE_INSIGHT_ID } from './constants';
import { RedirectUrlProps } from './types';

export const handleRedirectUrlToAlp = ({
  serviceId,
  equipmentInfo
}: RedirectUrlProps) => {
  if (serviceId && equipmentInfo?.seoUrl) {
    const redirectUrl = `${equipmentInfo?.seoUrl}?${SERVICE_INSIGHT_ID}=${encodeURIComponent(serviceId)}`;
    setSessionStorage(FOCUS_SERVICE_INSIGHT, 'true');
    window.location.href = redirectUrl;
  }
};
